import FilterTag, {
  Container as FilterTagContainer,
  ContainerFilled as FilterTagContainerFilled,
  Text as FilterTagText,
} from "@components/FilterTag"
import MegaMenuHeader from "@components/MegaMenu/MegaMenuHeader"
import breakpoints from "@constants/breakpoints"
import { getIn } from "@utils/index"
import {
  getShopURL,
  getShopURLForBrandDeviceType,
  getShopURLForDevice,
  getShopURLForDeviceType,
} from "@utils/urls"
import * as R from "ramda"
import React from "react"
import styled from "styled-components"

import { DesktopHeaderProps } from "./DesktopHeader"

const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

const FilterWrapper = styled.div`
  display: flex;
  margin-right: 8px;
  overflow: hidden;

  ${FilterTagContainer} {
    @media ${breakpoints.laptop} {
      overflow: hidden;
    }
  }

  ${FilterTagText} {
    @media ${breakpoints.laptop} {
      font-size: 11px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`

const SeriesTagWrapper = styled(FilterWrapper)`
  ${FilterTagContainerFilled} {
    opacity: 0.5;
  }
`

const DefaultHeaderContent: React.FC<DesktopHeaderProps> = (
  props: DesktopHeaderProps
) => {
  const showFilters = !R.isEmpty(props.filters) && props.showFilters
  const deviceType = getIn(props, "filters.deviceType")
  const brand = getIn(props, "filters.brand")
  const device = getIn(props, "filters.device")
  const series = getIn(props, "filters.series")

  return showFilters ? (
    <FilterContainer>
      <FilterWrapper>
        <FilterTag text="All" to={getShopURL()} />
      </FilterWrapper>
      {deviceType && (
        <FilterWrapper>
          <FilterTag
            text={deviceType.menuLabel || deviceType.name}
            to={getShopURLForDeviceType(deviceType.slug)}
          />
        </FilterWrapper>
      )}
      {deviceType && brand && (
        <FilterWrapper>
          <FilterTag
            text={brand.name}
            to={getShopURLForBrandDeviceType(brand.slug, deviceType.slug)}
          />
        </FilterWrapper>
      )}
      {deviceType && brand && device && (
        <FilterWrapper>
          <FilterTag text={device.name} to={getShopURLForDevice(device.slug)} />
        </FilterWrapper>
      )}
      {deviceType && brand && device && series && (
        <SeriesTagWrapper>
          <FilterTag text={series.name} />
        </SeriesTagWrapper>
      )}
    </FilterContainer>
  ) : (
    <MegaMenuHeader
      active={getIn(props, "megaMenuActiveItem")}
      headerRef={getIn(props, "megaMenuHeaderRef")}
      items={getIn(props, "megaMenuHeaderItems", [])}
    />
  )
}

export default DefaultHeaderContent
